import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from '../../Common';

export default function ProtectedContent({ authDep, loading, loadingMsg, children }) {
  return (
    <>
      {loading ? (
        <div className="checker-loader-container page-wrapper width-container">
          <Loader message={loadingMsg} />
        </div>
      ) : (
        <>{children({ isAuthed: authDep })}</>
      )}
    </>
  );
}
ProtectedContent.defaultProps = {
  loading: false,
  loadingMsg: '',
  authDep: true,
};
ProtectedContent.propTypes = {
  authDep: PropTypes.any,
  loadingMsg: PropTypes.string,
  loading: PropTypes.bool,
  children: PropTypes.func.isRequired,
};
